export default __webpack_public_path__ + "images/slideshow_arrow_black-c65d799dabac9265c34c29149b0a197c.svg";